export default __webpack_public_path__ + "static/media/9.21d0710c.jpg";